import * as R from "ramda";
const getActualContentConstraintsDefaultSelection = ({ contentConstraints, selection }) => R.pipe(
  R.pick(R.keys(contentConstraints)),
  R.mapObjIndexed((val, id) => {
    const setIds = R.prop(id)(contentConstraints);
    return R.filter((vId) => setIds.has(vId))(val);
  })
)(selection);
export {
  getActualContentConstraintsDefaultSelection as default
};
